import { render, staticRenderFns } from "./MapHatchForwardDiagonal.vue?vue&type=template&id=097052aa&scoped=true&"
import script from "./MapHatchForwardDiagonal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./MapHatchForwardDiagonal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097052aa",
  null
  
)

export default component.exports